import { Route } from '@angular/router';

import { NavbarComponent } from './layouts';

export const navbarRoute: Route = {
    path: '',
    component: NavbarComponent,
    outlet: 'navbar'
  };



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.route.ts